// organize-imports-ignore

/* @forbiddenImports sinon */

// This module is the main entry point. Requiring reflect-metadata here avoids forgetting it
import "reflect-metadata";

// By installing source map support, we get the original source
// locations in error messages
import { install as installSourceMapSupport } from "source-map-support";
installSourceMapSupport();

// Export some frequently-used things and types - this also loads all CC files including metadata
export * from "@zwave-js/cc";
export * from "./Controller.js";
export * from "./Driver.js";
export * from "./Error.js";
export * from "./Node.js";
export * from "./RCPHost.js";
export * from "./Utils.js";
export * from "./Values.js";
export * from "./Zniffer.js";
